import React, { useState } from "react";
import Beatloader from "../../../Common/Loaders/Beatloader";
import VoucherProcessingReceiptVoucher from "./VoucherProcessingReceiptVoucher";
import VoucherProcessingReceiptVoucherEntry from "./VoucherProcessingReceiptVoucherEntry";
import VoucherProcessingReceiptSearch from "./VoucherProcessingReceiptSearch";
import VoucherProcessingRemittanceClubbing from "./VoucherProcessingRemittanceClubbing";
import VoucherProcessingRemittancePosting from "./VoucherProcessingRemittancePosting";
import VoucherProcessingReceiptVoucherEntryOne from "./VoucherProcessingReceiptVoucherEntryOne";
import VoucherProcessingJournalVoucher from "./VoucherProcessingJournalVoucher";

const VoucherProcessing = () => {
  const [activeTab, setActiveTab] = useState("receipt_voucher");
  const [pageLoader, setPageLoader] = useState(false);
  const [postPreData, setPostPreData] = useState({
    // remittance_id: "REM-2025",
    // remittance_date: "2025-01-10",
    // party_name: "jj",
    // currency: "USD",
    // remittance_amount: "1234",
    // base_amount: "12",
    // invoice_amount: "12345",
    // exchange_variance: "5454",
    // remittance_status: "Draft",
    remittance_id: "",
    remittance_date: "",
    party_name: "",
    currency: "",
    remittance_amount: "",
    base_amount: "",
    invoice_amount: "",
    exchange_variance: "",
    remittance_status: "",
  });

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${activeTab === id
          ? "btn-light shadow-sm border"
          : "btn-outline-light text-muted border"
        }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );


  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Tabs */}
            <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
              <TabButton id="receipt_voucher" label="Receipt Voucher" />
              <TabButton
                id="receipt_voucher_enter"
                label="Receipt Voucher Enter"
              />
              {/* <TabButton
                id="remittance_voucher_enter"
                label="Remittance Voucher Enter"
              /> */}
              <TabButton id="journal_voucher" label="Journal Voucher" />
              <TabButton id="remittance_search" label="Remittance Search" />
              <TabButton id="remittance_clubbing" label="Remittance Clubbing" />
              <TabButton id="remittance_posting" label="Remittance Posting" />
            </div>

            <div className="p-4">
              {/* GROUP FORM -------------------------------------------------- */}
              {activeTab === "receipt_voucher" && (
                <VoucherProcessingReceiptVoucher setActiveTab={setActiveTab} />
              )}

              {activeTab === "receipt_voucher_enter" && (
                <VoucherProcessingReceiptVoucherEntryOne setActiveTab={setActiveTab}/>
              )}

              {/* remittance_voucher_enter */}
              {/* {activeTab === "remittance_voucher_enter" && (
                <VoucherProcessingReceiptVoucherEntry />
              )} */}

              {activeTab === "journal_voucher" && (
                <VoucherProcessingJournalVoucher />
              )}

              {/* remittance_search */}
              {activeTab === "remittance_search" && (
                <VoucherProcessingReceiptSearch
                  setActiveTab={setActiveTab}
                />
              )}

              {/* remittance_clubbing */}
              {activeTab === "remittance_clubbing" && (
                <VoucherProcessingRemittanceClubbing
                  setPostPreData={setPostPreData}
                  postPreData={postPreData}
                  setActiveTab={setActiveTab}
                />
              )}

              {/* remittance_posting */}
              {activeTab === "remittance_posting" && (
                <VoucherProcessingRemittancePosting
                  setPostPreData={setPostPreData}
                  postPreData={postPreData}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VoucherProcessing;
